import React from 'react';

function CheckboxControl() {
  return (
    <div className="checkbox-nolabel">
      <input name="check_0" id="check_0" type="checkbox" />
      <label htmlFor="check_0" className="cus-chklabel" />
    </div>
  );
}

export default CheckboxControl;
